<template>
  <v-card class="card">
    <div v-if="head" class="head d-flex align-stretch justify-space-between">
      <div class="card-title pl-7 pr-7 py-1">{{title}}</div>
      <v-btn v-if="more" class="btn-more px-5" text @click="onClick">更多<v-icon>mdi-chevron-right</v-icon></v-btn>
    </div>
    <div class="content">
      <slot></slot>
    </div>
  </v-card>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: ''
    },
    head: {
      type: Boolean,
      default: false
    },
    more: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    onClick () {
      this.$emit('more')
    }
  }
}
</script>

<style lang="scss" scoped>
.card {
  overflow: hidden;
  border-radius: 0!important;
  background-color: transparent!important;
  box-shadow: none!important;
  .head {
    // background-color: #458ee5;
    .card-title {
      background-color: $main-color;
      font-size: 18px;
      font-weight: bold;
      color: #FFF;
    }
    .btn-more {
      height: auto;
      color: $main-color;
    }
  }
  .content {
    background-color: transparent!important;
  }
}
</style>
